import { isProd } from '@biniyog/common';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyCMYKPbFfuS6dqW4pON5zzFQeTiSk7pP2I',
  authDomain: 'biniyog-web-dev.firebaseapp.com',
  projectId: 'biniyog-web-dev',
  storageBucket: 'biniyog-web-dev.appspot.com',
  messagingSenderId: '843292816300',
  appId: '1:843292816300:web:35faa6bcd8d36f0bb70009',
  measurementId: 'G-30S8RKT2B8',
};

const firebaseConfigProd = {
  apiKey: 'AIzaSyBNPs3WiWxjy2YuLzvIhoWSiGmDOdCUnHw',
  authDomain: 'biniyog-b8940.firebaseapp.com',
  projectId: 'biniyog-b8940',
  storageBucket: 'biniyog-b8940.appspot.com',
  messagingSenderId: '17324387876',
  appId: '1:17324387876:web:e31ef28f9c3ae077c0b2b1',
  measurementId: 'G-MDN4KY3DV1',
};

// Initialize Firebase
const app = initializeApp(isProd() ? firebaseConfigProd : firebaseConfig, 'biniyog-web-dev');
const analytics = getAnalytics(app);

export const firebaseLogEvent = (eventName: string, ...rest) => {
  logEvent(analytics, eventName, ...rest);
};
